<template>
    <table style="margin-top: 250px;">
        <thead>
            <tr>
                <th v-for="dayofweek in days" class="week" style="text-align: center;">{{dayofweek[0]}}</th>
            </tr>
        </thead>
        <tbody v-if="loaded">
            <tr>
                <template v-for="(day, index) in days">
                    <draggable tag="td" :list="day[1]" group="days" @end="dragend">
                        <div style="padding-left: 5px; height: 40px;" class="upper" v-for="(task, index) in day[1]" v-bind:class="{ 
                          intervention: task.kind == 'intervention',
                          inspection: task.kind == 'inspection',
                          installation: task.kind == 'installation',
                          other: task.typeof == 'other',
                          taskfinished: (task.status == 'finished_worker' | task.status == 'finished' | task.status == 'cancelled' | task.status == 'cleared')
                        }" v-on:click="showTask(task)"
                        :taskid="task.id">
                            <div>
                                <div class="circle">{{initialsById(task.worker_ids)}}</div>
                                <div class="circle" v-if="task.worker_ids.length > 1"></div>
                            </div>
                            <p style="padding-left: 35px;">{{task | getTaskWeekText}}</p>
                        </div>
                    </draggable>
                </template>
            </tr>
        </tbody>
        <preloader v-if="loaded == false" n="6" />
    </table>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import Moment from 'moment';
import 'moment/locale/pl'
import { extendMoment } from 'moment-range';
import VueCookies from 'vue-cookies'

const moment = extendMoment(Moment);
moment.locale('pl')
export default {
    data: function() {
        return {
            tasksnames: {
                'intervention': "Interwencja",
                'inspection': "Kontrola",
                "installation": 'Montaż',
                'other': "Inne"
            },
            intervention_types: {
                'deratization': "deratyzacja",
                'disinfection': "dezynfekcja",
                'disinsection': "dezynsekcja",
                'other': "Inny"
            }
        }
    },
    props: {
        loaded: Boolean,
        days: {
            type: Array,
            default: []
        },
        workerItems: {
            type: Array,
            default: []
        },
        placesdict: {
            type: Object,
            default: {}
        }
    },
    created() {},
    mounted() {},
    methods: {
        initialsById(workers) {
            if (_.keyBy(this.workerItems, 'value')[workers[0]] == undefined) return "."
            return _.keyBy(this.workerItems, 'value')[workers[0]].symbol
        },
        showTask(task, ) {
            this.$emit('click', task)
        },
        dragend(evt) {
            for (var i = this.days.length - 1; i >= 0; i--) {
                for (var j = this.days[i][1].length - 1; j >= 0; j--) {
                    var task = this.days[i][1][j];
                    if ((moment(task.startsAt).day() - 1, 'yyyy-MM-DDTHH:mm') != i) {
                        var newday = i - ((6 + moment(task.startsAt, 'yyyy-MM-DDTHH:mm').day()) % 7);
                        task.startsAt = moment(task.startsAt, 'yyyy-MM-DDTHH:mm').add(newday, 'days').format('yyyy-MM-DDTHH:mm')
                        task.endsAt = moment(task.endsAt, 'yyyy-MM-DDTHH:mm').add(newday, 'days').format('yyyy-MM-DDTHH:mm')
                        this.days[i][1][j] = task;
                        this.$emit('taskmoved', task);
                    }
                }
            }
        }
    },
    watch: {},
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

/*p {
  font-size: 2em;
  text-align: center;
}*/
thead {
    font-size: 15px;
}

thead th {
    font-weight: 300;

}

table thead th:first-child {
    position: sticky;
    z-index: 2;
}

table>tr>td {

    padding-bottom: 5px;
}

thead>tr>td {
    padding-top: 5px;
}

.btn {
    color: black;
}

.btn.grey {
    background-color: #DADADA !important;
}

thead .input-field {
    margin-top: unset;
    padding-top: 5px;
    margin-bottom: unset;
}

.maincontainer {
    margin: 0px;
}

.calendartable td {
    padding: 0px 3px;
    font-size: 12px;
    text-align: center;
}

.calendartable tr {
    border-bottom: 0px;
}

.calendartable .red {
    background-color: #bbb;
    border-radius: 50%;
    text-align: center;
}

.calendartable .small {
    font-size: 2em;
}

.modal select {
    display: block !important;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.btn-add {
    border-radius: 8px;
    margin-top: 16px;
}

.task {
    position: absolute;
    max-width: 200px;
    width: 200px;
}

.intervention {
    background-color: rgba(244, 60, 250, 0.25);
}

.inspection {
    background-color: rgba(250, 244, 60, 0.25);
}

.installation {
    background-color: rgba(66, 250, 60, 0.25);
}

.other {
    background-color: rgba(60, 117, 250, 0.25);
}

.intervention,
.inspection,
.installation,
.other {
    padding: 5px;
}

th {
    position: sticky;
}

.circle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background-color: #DADADA;
    text-align: center;
    display: inline-block;
}

.modal {
    top: 2% !important;
    max-height: 100%;
    background-color: #dadada;
}

.modal .modal-footer {
    background-color: #dadada;
}

.modal .btn-large {
    border-radius: 8px;
    color: black;
}

.label {
    line-height: 2;
}

.modal .green {
    margin-top: 10px;
    margin-bottom: 10px;
}

p {
    font-size: 10px;
    line-height: 2em;
}

.inspection {

    background-color: rgba(250, 244, 60, 0.25);
    font-size: medium;
}

.intervention {

    background-color: rgba(244, 60, 250, 0.25);
    font-size: medium;
}

/*.installation {

  background-color: rgba(60, 117, 250, 0.25);
  font-size: medium;
}*/
.week {
    width: calc(1 / 7 * 100%);

}

.daycolumn {
    width: calc(1 / 7 * 100%);
}

.cell {
    border: 1px solid;
    height: 200px;
    vertical-align: baseline;
}

.tasklist {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(5, 25px);
    grid-row-start: -1;
}

.tasklist>div {
    height: 25px;
}

.upper {
    text-transform: uppercase;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 5px;
    font-size: 12px;
}

.upper .circle {
    font-size: 15px;
}

.rightalign {
    text-align: end;
}

.workerheader-open>div {
    width: 200px;
}

.workerheader-closed>div {
    width: 23px;
}

/deep/ .collapsible-header {
    background-color: gray;
}

.collapsible i {
    right: 54%;
}

.hourtable th:first-child {
    padding-left: 16px;
}

/deep/ .dropdown-content {
    z-index: 102;
}

/deep/ .timepicker-modal {
    width: 75% !important;
}

/deep/ .timepicker-digital-display {
    background-color: #c22026 !important;
}

/deep/ .timepicker-canvas-bg {
    fill: #c22026 !important;
}

/deep/ .timepicker-canvas line {
    stroke: #c22026 !important;
}

/deep/ .timepicker-canvas-bearing {
    fill: #c22026 !important;
}

/deep/ .timepicker-tick:hover {
    background: #c22026 !important;
}

/deep/ .timepicker-close {
    color: #c22026 !important;
}

.removephoto {
    vertical-align: top;
    float: right;
    background-color: black;
    border: none;
    border-radius: 15px;
}

.removephoto i {
    color: white;
}

/deep/ ul#dropdownselectorplace {
    padding: 5px;
}

/deep/ ul#dropdownselectorplace label {
    color: black !important;
    font-size: 10px;
}

.task hr {
    margin: 0px !important;
    border-bottom-width: 0px;
    border-color: black;
}

.circle {
    position: absolute;
    border: solid 1px;
    line-height: 2;
}

.circle:nth-child(1) {
    z-index: 2;
}

.circle:nth-child(2) {

    margin-top: -3px;
    margin-left: -3px;
}

td {
    vertical-align: baseline !important;
}

td p {
    margin: 0px;
}
</style>